import {
  ChevronUp,
  Edit,
  Eye,
  RotateCcw,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";                                                                                                                                                                                                         
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Brand from "../../core/modals/inventory/brand";
import { all_routes } from "../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Table from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import { Download } from "react-feather";
import { useDeleteProductMutation, useGetProductListQuery } from "../../core/redux/api/productApi";
import toast from "react-hot-toast";

import { exportToPDF, exportToExcel } from "../utils/exportUtils2";
// import { exportToExcel } from './exportUtils';
import 'jspdf-autotable';

const ProductList = () => {
  const { data: dataSource, isLoading, error, refetch } = useGetProductListQuery();

  const [exportLoading, setExportLoading] = useState(false);
  const [exportError, setExportError] = useState(null);

  const dispatch = useDispatch();
  const [deleteProduct] = useDeleteProductMutation();
  const [productToDelete, setProductToDelete] = useState(null);
  const data = useSelector((state) => state.rootReducer.toggle_header);

  // useEffect(() => {
  //     refetch(); 
  //   }, []);
  const route = all_routes;

const flattenProductData = (products) => {
  return products?.map(product => ({
    ...product,
    categoryName: product.category?.categoryName || product.category?.name || 'N/A',
    unitName: product.unit?.unitName || 'N/A',
    createdByName: product.createdBy?.firstName || 'Admin'
  })) || [];
};

const pdfOptions = {
  title: 'Product List Report',
  columns: [
    { key: 'productId', header: 'ID' },
    { key: 'productName', header: 'Name' },
    { key: 'categoryName', header: 'Category' },
    { 
      key: 'saleRate', 
      header: 'Price',
      format: (value) => `${(value || 0).toFixed(2)}`
    },
    { key: 'unitName', header: 'Unit' },
    { key: 'quantity', header: 'Qty' },
    { key: 'createdByName', header: 'Created By' }
  ],
  data: flattenProductData(dataSource?.data),
  fileName: 'products_export',
  orientation: 'landscape'
};

const excelOptions = {
  columns: [
    { key: 'productId', header: 'Product ID' },
    { key: 'productName', header: 'Product Name' },
    { key: 'categoryName', header: 'Category' },
    { 
      key: 'saleRate', 
      header: 'Sale Rate',
      format: (value) => (value || 0).toFixed(2)
    },
    { key: 'unitName', header: 'Unit' },
    { key: 'quantity', header: 'Quantity' },
    { key: 'createdByName', header: 'Created By' }
  ],
  data: flattenProductData(dataSource?.data),
  fileName: 'products_export',
  sheetName: 'Products'
};

  const handleDeleteProduct = async () => {
    if (!productToDelete) return;

    try {
      // console.log("productToDelete", productToDelete);
      await deleteProduct(productToDelete).unwrap();

      // Success - refetch the products
      // await refetch();

      toast.success("Product deleted successfully");
    } catch (error) {
      toast.error("Failed to delete product");
    }

    setProductToDelete(null);
  };
  if (isLoading) return <div className="text-center py-4">Loading products...</div>;
  if (error) return <div className="alert alert-danger">Error: {error.message}</div>;
  if (!dataSource) return <div className="alert alert-warning">No products found</div>;
  const columns = [
    {
      title: "Product Id",
      dataIndex: "productId",
      sorter: (a, b) => a.productId.length - b.productId.length,
      responsive: ['lg', 'xl']
    },
    {
      title: "Image",
      dataIndex: "name",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md me-2">
            {record.image && record.image.length > 0 ? (
              <img
                src={record.image[0]}
                alt={text}
                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'path-to-fallback-image.png';
                }}
              />
            ) : (
              <div style={{
                width: '40px',
                height: '40px',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                No Image
              </div>
            )}
          </Link>
        </div>
      ),
      // sorter: (a, b) => a.name.length - b.name.length,
      responsive: ['md', 'lg', 'xl']
    },
    {
      title: "Item Name",
      dataIndex: "productName",
      sorter: (a, b) => a.productName.length - b.productName.length,
      // Always visible
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (category) => category?.name || '',
      sorter: (a, b) => a.category.length - b.category.length,
      responsive: ['lg', 'xl']
    },
    {
      title: "Sale Rate",
      dataIndex: "saleRate",
      sorter: (a, b) => a.saleRate - b.saleRate,
      responsive: ['lg', 'xl']
    },
    {
      title: "Unit",
      dataIndex: "unit",
      render: (unit) => unit?.unitName || '1',
      sorter: (a, b) => a.unit.length - b.unit.length,
      responsive: ['lg', 'xl']
    },
    // {
    //   title: "Qty",
    //   dataIndex: "quantity",
    //   sorter: (a, b) => a.qty.length - b.qty.length,
    //   responsive: ['lg', 'xl']
    // },
    {
      title: "Created By",
      dataIndex: "createdBy",
      render: (createdBy) => createdBy?.firstName || 'Admin',
      sorter: (a, b) => (a.createdBy?.firstName || 'Admin').length - (b.createdBy?.firstName || '').length,
      responsive: ['xl']
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to={route.productdetails.replace(':_id', record._id)}
            >
              <Eye className="feather-view" />
            </Link>
            <Link
              className="me-2 p-2"
              to={route.editproduct.replace(':_id', record._id)}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="confirm-text p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={() => setProductToDelete(record?._id)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      // Always visible
    }
  ];

  const expandable = {
    expandedRowRender: (record) => (
      <div style={{ padding: '10px 50px' }}>
        <div className="row">
          <div className="col-6 col-md-3">
            <strong>Product ID:</strong> {record.productId}
          </div>
          <div className="col-6 col-md-3">
            <strong>Category:</strong> {record.category?.name || '-'}
          </div>
          <div className="col-6 col-md-3">
            <strong>Sale Rate:</strong> {record.saleRate}
          </div>
          <div className="col-6 col-md-3">
            <strong>Unit:</strong> {record.unit?.unitName || '-'}
          </div>
          <div className="col-6 col-md-3">
            <strong>Qty:</strong> {record.quantity}
          </div>
          <div className="col-6 col-md-3">
            <strong>Created By:</strong> {record.createdBy?.firstName || 'Admin'}
          </div>
        </div>
      </div>
    ),
    rowExpandable: (record) => true,
  };

  // const filtersConfig = [
  //   {
  //     key: 'category',
  //     title: 'Category',
  //     options: Array.from(new Set(dataSource?.data
  //       .map(item => item.category?.name)
  //       .filter(name => name) 
  //     )) || [],
  //     render: (value) => value 
  //   }
  // ];

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Product List</h4>
                <h6>Manage your products</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                    
                      exportToPDF(pdfOptions);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="PDF Export" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link
                    to="#" // Add this to prevent default navigation
                    onClick={(e) => {
                      e.preventDefault();
                    exportToExcel(excelOptions)}
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    {exportLoading ? (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    ) : (
                      <ImageWithBasePath src="assets/img/icons/excel.svg" alt="Excel Export" />
                    )}
                  </Link>
                </OverlayTrigger>
              </li>

              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              <Link to={route.addproduct} className="btn btn-primary">
                <i className='ti ti-circle-plus me-1'></i>
                Add New Product
              </Link>
            </div>
            <div className="page-btn import">
              <Link
                to="#"
                className="btn btn-secondary color"
                data-bs-toggle="modal"
                data-bs-target="#view-notes"
              >
                <Download className="feather me-2" />
                Import Product
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
              </div>

            </div>
            <div className="card-body">
              <div className="table-responsive">
                <Table columns={columns} dataSource={dataSource?.data} expandable={expandable} />
              </div>
            </div>
          </div>
          {/* /product list */}
          <Brand />
        </div>
      </div>
      <>
        {/* delete modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="page-wrapper-new p-0">
                <div className="content p-5 px-3 text-center">
                  <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                    <i className="ti ti-trash fs-24 text-danger" />
                  </span>
                  <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                    Delete Product
                  </h4>
                  <p className="text-gray-6 mb-0 fs-16">
                    Are you sure you want to delete product?
                  </p>
                  <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary fs-13 fw-medium p-2 px-3" data-bs-dismiss="modal"
                      onClick={handleDeleteProduct}
                    >
                      Yes Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

    </>

  );
};

export default ProductList;